// @ts-nocheck
import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { notification } from 'antd';
import { useSessionToken } from '../../../contexts/SessionContext';
import TextField from '../../../components/TextField';
import Button from '../../../components/Button';

const DownloadDatabase = (props) => {
  const { sessionToken } = useSessionToken();
  const [actionType, setActionType] = useState(null); // 'download' or 'info'
  const [dbInfo, setDbInfo] = useState([]);

  const schema = yup.object({
    email: yup.string().email().required('Valid email is required').nullable(),
    password: yup.string().required('Password is required').nullable(),
  });

  const {
    handleSubmit,
    control,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
  });

  const onSubmit = async (data) => {
    try {
      const isInfo = actionType === 'info';
      const endpoint = isInfo
        ? `${process.env.REACT_APP_BASE_URL}/export/get-db-collections`
        : `${process.env.REACT_APP_BASE_URL}/export/db-export`;
      const response = await fetch(endpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          "Authorization": `Bearer ${sessionToken?.rawValue}`
        },
        body: JSON.stringify(data),
      });
  
      if (!response.ok) {
        const responseData = await response.json();
        notification.success({ message: responseData.message || 'Failed to download the database' });
        return;
      }
      if (isInfo) {
        const responseData = await response.json();
        setDbInfo(responseData);
        notification.success({ message: 'Database info retrieved successfully' });
        console.log('Database Info:', responseData);
      } else {
        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
    
        const a = document.createElement('a');
        const timestamp = new Date().toISOString().replace(/[:.]/g, '-');
        a.href = url;
        a.download = `db_export_${timestamp}.json`;
        document.body.appendChild(a);
        a.click();
    
        // Clean up
        a.remove();
        window.URL.revokeObjectURL(url);
        notification.success({ message: responseData.message || 'Successfully downloaded the database' });
      }
    } catch (error) {
      notification.success({ message: error?.message || 'Failed to download the database' });
    }
  };

  if (!sessionToken?.user.isSuperAdmin) {
    return (
      <div className="flex justify-center items-center w-auto h-screen font-semibold text-xl text-gray-500">
        You do not have permission to view this page.
      </div>
    );
  }

  return (
    <div className="w-full h-screen pt-8 pb-12 bg-purple-50 flex-col justify-start items-start gap-8 inline-flex">
      <div className="self-stretch px-12 justify-between items-center inline-flex">
        <div className="text-indigo-600 text-xl font-semibold font-['Manrope']">
          Download Database
        </div>
      </div>
      <div className="self-stretch px-12 justify-start items-start gap-[26px] inline-flex">
        <div
          className="w-[800px] self-stretch p-6 bg-white rounded-lg flex-col
            items-start gap-4 inline-flex"
        >
          <form onSubmit={handleSubmit(onSubmit)} autoComplete="off" className="w-full">
            <div className="grid grid-cols-12 gap-6 w-full">
              <div className="col-span-12">
                <TextField
                  name="email"
                  type="text"
                  label="Enter user email"
                  control={control}
                  errors={errors}
                  customlabelclass="text-zinc-700 !text-sm !font-normal font-['Manrope'] !pb-2"
                />
              </div>
              <div className="col-span-12">
              <TextField
                  name="password"
                  type="password"
                  label="Enter password"
                  control={control}
                  errors={errors}
                  customlabelclass="text-zinc-700 !text-sm !font-normal font-['Manrope'] !pb-2"
                />
              </div>
              <div className="col-span-12 flex justify-start gap-3">
                <Button
                  customClass=""
                  variant="primary"
                  type="submit"
                  onClick={(() => setActionType('download'))}
                >
                  <div className="text-white text-base font-bold font-['Manrope']">Download Database</div>
                </Button>
                <Button
                  customClass=""
                  variant="primary"
                  type="submit"
                  onClick={(() => setActionType('info'))}
                >
                  <div className="text-white text-base font-bold font-['Manrope']">View Database Info</div>
                </Button>
              </div>
            </div>
          </form>
        </div>
      </div>
      {dbInfo.length > 0 && (
        <div className="px-12 pb-12 w-full">
          <div className="text-indigo-600 pb-6 text-xl font-semibold font-['Manrope']">Collections Info</div>
          <table className="min-w-full bg-white border border-gray-200 rounded">
            <thead>
              <tr className="bg-gray-100 text-left text-sm font-medium text-gray-700">
                <th className="py-2 px-4 border-b">Collection</th>
                <th className="py-2 px-4 border-b">Document Count</th>
              </tr>
            </thead>
            <tbody>
              {dbInfo.map((item) => (
                <tr key={item.collection} className="text-sm text-gray-800">
                  <td className="py-2 px-4 border-b">{item.collection}</td>
                  <td className="py-2 px-4 border-b">{item.count}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default DownloadDatabase;
